/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChatTransfer = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M5.5 22H2V2h20v16H8.5zM4 20h.5l3-4H20V4H4zm8.7-6.3-1.4-1.4 1.3-1.3H8V9h4.6l-1.3-1.3 1.4-1.4 3.7 3.7z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgChatTransfer as ChatTransfer };
